<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <p>El contrato se ha creado correctamente, se enviará propuesta al email del cliente.</p>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal"
      @click="close()">Cerrar</button>
  </Modal>
</template>

<script>
import Modal from '../../../Shared/Modal.vue';

export default {
  name: 'ModalFinal',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
  ],
  components: {
    Modal
  },
  data() {
    return {
      classes: this.class
    }
  },
  methods: {
    close() {
      this.$router.push({ name: 'newContractStep1' })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
